import React from 'react'
import { I18N, variantProvider } from '@/app'
import { ActionIcon, Button, Modal, Text, View } from '@/components'
import { ScoreScale } from '../atoms/ScoreScale'
import { useModal } from '@/utils'

export function NPS({ organisation }) {
  const { t } = I18N
  const answers = organisation?.nps.number_of_answers
  const modalContext = useModal()

  function openModal() {
    modalContext.toggle()
  }

  return (
    <>
      <View css={styles.wrapper}>
        <View css={styles.innerWrapper}>
          <Text text={t('climateNPS.title')} variants={['h3']} />
          <ActionIcon
            name="info"
            variants={['primary:outline', 'noBorder']}
            debugName="NPS info action icon"
            onPress={openModal}
          />
        </View>
        <ScoreScale score={organisation?.nps.score} text={t('climateNPS.avarageScore')} />
        <Text variants={['p4', 'textCenter']} text={t('climateNPS.answers', { qtd: answers })} />
      </View>
      <Modal {...modalContext} css={styles.modal} showClose={false} variants={['centered']}>
        <View variants={['gap:2', 'column']}>
          <Text variants={['h1', 'textCenter']} text={t('climateNPS.modal.title')} />
          <Text variants={['p1', 'textCenter']} text={t('climateNPS.modal.description')} />
          <Button text={t('dismiss')} debugName={`Pressed dismiss climate nps modal`} onPress={openModal} />
        </View>
      </Modal>
    </>
  )
}

const MODAL_WIDTH = 523

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      ...theme.effects.light,
      ...theme.presets.column,
      ...theme.spacing.gap(2),
      ...theme.spacing.padding(4),
      backgroundColor: theme.colors.neutral1,
      borderRadius: theme.borderRadius.large,
      [theme.media.down('small')]: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        ...theme.effects.reviewElevation
      }
    },
    innerWrapper: {
      ...theme.presets.row,
      ...theme.presets.fullWidth,
      ...theme.presets.justifySpaceBetween
    },
    modal: {
      maxWidth: MODAL_WIDTH,
      ...theme.spacing.padding(4)
    }
  }),
  true
)
